import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function GuaranteeSection() {
  return <section className="bg-brand-sand px-4 py-20" data-id="element-79" data-mp="4vs1604r2hrx">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-80" data-mp="9umi0wj5pw9e">
        <div className="mb-6 inline-flex h-16 w-16 items-center justify-center rounded-full bg-white shadow-sm" data-id="element-81" data-mp="9t1lx2h7259f">
          <ShieldCheckIcon className="h-8 w-8 text-brand-sageInk" aria-hidden="true" data-id="element-82" data-mp="ercwxgj86lt8" />
        </div>
        <h2 className="text-2xl font-black tracking-wide text-brand-slate md:text-3xl" data-id="element-83" data-mp="jqg00vfnahyk">
          🛡️ Reprenez votre argent et gardez le matériel.
        </h2>
        <p className="mt-6 leading-relaxed text-brand-gray" data-id="element-84" data-mp="slvvfgw1t569">
          Essayez Pilates Reformer Prêt™️ pendant 30 jours complets. Si le système ne correspond pas à ce que vous
          cherchiez pour vos cours, écrivez-nous et nous vous remboursons intégralement — sans justification compliquée,
          et vous gardez tout le matériel déjà téléchargé.
        </p>
      </Reveal>
    </section>;
}